module.exports = __webpack_public_path__ + "img/aboutLogo.923eb4cf.png";